<template>
  <div id="SubstationManagement">
    <div class="subcontainer-one">
      <div class="icon-left" @click="show=!show" v-if="projectId==20"><i class="el-icon-caret-left"></i></div>
      <div class="icon-right" @click="show=!show"  v-if="projectId==20"><i class="el-icon-caret-right"></i></div>
      <div class="imgshow" v-if="!show&&projectId==20" ><img src="../../assets/img/csy.jpg" alt=""></div>
      <div class="top" v-if="show">
        <div class="plan yuan">
          <div class="name">源</div>
          <div class="cont">
            <div :class="item.isclick?'item animationSource':'item  animationNo gray'" v-for="(item,index) in menu[0]"
                 :key="index" @click="tagmenu(item)">
              <img :src="!item.isclick?item.imgno:item.img" alt="">
              <span>{{ item.name }}</span>
            </div>
            <!-- <div class="item">
                <img src=".././../assets/img/icon10.png" alt="">
                <span>光伏电站</span>
            </div>
            <div class="item">
                <img src=".././../assets/img/icon3.png" alt="">
                <span>柴油发电机</span>
            </div> -->
          </div>
        </div>
        <div class="plan wang">
          <div class="name">网</div>
          <div class="cont">
            <div :class="item.isclick?'item animationNet':'item  animationNo gray'" v-for="(item,index) in menu[1]"
                 :key="index" @click="tagmenu(item)">
              <img :src="!item.isclick?item.imgno:item.img" alt="">
              <span>{{ item.name }}</span>
            </div>
            <!-- <div class="item">
                <img src=".././../assets/img/icon14.png" alt="">
                <span>一次系统图</span>
            </div>
            <div class="item">
                <img src=".././../assets/img/icon15.png" alt="">
                <span>电能质量</span>
            </div> -->
          </div>
        </div>
      </div>

      <div class="center" v-if="show">
        <div class="left">
          <div class="box box1">
            <div class="plan jiesuan">
              <div :class="item.isclick?'item animationEnergy':'item  animationNo gray'" v-for="(item,index) in menu[2]"
                   :key="index">
                <img :src="!item.isclick?item.imgno:item.img" alt="">
                <span>{{ item.name }}</span>
              </div>
            </div>
            <div class="plan dianl" @click="$router.push('/3D')">
              <!-- <div class="item" v-for="(item,index) in menu[6]" :key="index" @click="tagmenu(item)"  :class="{gray:!item.isclick}">
                  <img :src="!item.isclick?item.imgno:item.img" alt="">
                  <span>{{item.name}}</span>
              </div> -->
              <video id="video" style="width: 100%; height: 100%; object-fit: fill" autoplay loop muted>
                <source src="../../assets/mp4/3Droom.mp4" type="video/mp4"/>
              </video>
            </div>
          </div>
          <div class="box box2">
            <div class="plan yunwei">
              <div class="name">运维</div>
              <div class="cont">
                <div :class="item.isclick?'item animation':'item  animationNo gray'" v-for="(item,index) in menu[3]"
                     :key="index" @click="tagmenu(item)">
                  <img :src="!item.isclick?item.imgno:item.img" alt="">
                  <span>{{ item.name }}</span>
                </div>
                <!-- <div class="item">
                    <img src=".././../assets/img/icon13.png" alt="">
                    <span>计费管理</span>
                </div>
                <div class="item">
                    <img src=".././../assets/img/icon11.png" alt="">
                    <span>设备台账</span>
                </div> -->
              </div>
            </div>
            <div class="plan chong" :class="item.isclick?'':'gray'"  v-for="(item,index) in menu[7]" :key="index">
              <div class="cont">
                <div class="name">充</div>
                <div :class="item.isclick?'item animationFill':'item  animationNo gray'"
                      @click="tagmenu(item)">
                  <img :src="!item.isclick?item.imgno:item.img" alt="">
                  <span>{{ item.name }}</span>
                </div>
              </div>
            </div>
            <div class="plan chu" :class="item.isclick?'':'gray'" v-for="(item,index) in menu[4]" :key="index">
              <div class="cont">
                <div class="name">储</div>
                <div :class="item.isclick?'item animationFill':'item  animationNo gray'" @click="tagmenu(item)">
                  <img :src="!item.isclick?item.imgno:item.img" alt="">
                  <span>{{ item.name }}</span>
                </div>
              </div>
            </div>
          </div>
        </div>
        <div class="right">
          <div class="plan he">
            <div class="name">荷</div>
            <div :class="item.isclick?'item animationDouch':'item  animationNo gray'" v-for="(item,index) in menu[5]"
                 :key="index" @click="tagmenu(item)">
              <img :src="!item.isclick?item.imgno:item.img" alt="">
              <span>{{ item.name }}</span>
            </div>
            <!-- <div class="item">
                <img src=".././../assets/img/icon6.png" alt="">
                <span>负荷模式</span>
            </div>
            <div class="item">
                <img src=".././../assets/img/icon7.png" alt="">
                <span>能耗分析</span>
            </div> -->
          </div>
        </div>
      </div>
    </div>
    <div class="subcontainer-thr">
      <Diagram></Diagram>
    </div>
  </div>
</template>

<script>
import Park from "../../components/common/Park";
import Diagram from "./components/Diagram";
import Monitor from "../../components/common/Monitor";

export default {
  data() {
    return {
      show:true
    }
  },
  components: {
    Park, Diagram, Monitor
  },
  computed: {
    projectId() {
      return this.$store.getters.projectId
    },
    projectInfo() {
      return this.$store.getters.selProjectInfo
    },
    menu() {
      let menu = [
        [
          {
            name: "电网来源",
            img: require('@/assets/img/icon19.png'),
            imgno: require('@/assets/img/icon19-a.png'),
            isclick: false,
          },
          {
            name: "光伏电站",
            img: require('@/assets/img/icon10.png'),
            imgno: require('@/assets/img/icon10-a.png'),
            isclick: false,
            url: "/Home/Photovoltaic/index"
          },
          {
            name: "柴油发电机",
            img: require('@/assets/img/icon17.png'),
            imgno: require('@/assets/img/icon17-a.png'),
            isclick: false,
          }
        ],
        [
          {
            name: "变配电站",
            img: require('@/assets/img/icon9.png'),
            imgno: require('@/assets/img/icon9-a.png'),
            isclick: false,
            url: "/Home/PowerDistribution/index"
          },
          {
            name: "一次系统图",
            img: require('@/assets/img/icon14.png'),
            imgno: require('@/assets/img/icon14-a.png'),
            isclick: false,
            url: "/Home/Overview/WiringLine"
          },
          {
            url: "/Home/Overview/LoopMonitoring",
            name: "回路监测",
            img: require('@/assets/img/icon23.png'),
            imgno: require('@/assets/img/icon23-a.png'),
            isclick: false,
          }
        ],
        [
          {
            name: "电力结算",
            img: require('@/assets/img/icon18.png'),
            imgno: require('@/assets/img/icon18-a.png'),
            isclick: false,
          }
        ],
        [
          {
            url: "/Home/Overview/EventManagement",
            name: "历史事件",
            img: require('@/assets/img/icon12.png'),
            imgno: require('@/assets/img/icon12-a.png'),
            isclick: false,
          }, {
          url: "/Home/Overview/MeterReading",
          name: "远程抄表",
          img: require('@/assets/img/icon11.png'),
          imgno: require('@/assets/img/icon11-a.png'),
          isclick: false,
        }, {
          url: "/Home/Overview/EquipmentAccount",
          name: "设备台账",
          img: require('@/assets/img/icon13.png'),
          imgno: require('@/assets/img/icon13-a.png'),
          isclick: false,
        }
        ], [
          {
            url: "/Home/PowerStation/index",
            name: "储能电站",
            img: require('@/assets/img/icon16.png'),
            imgno: require('@/assets/img/icon16-a.png'),
            isclick: false,
          }
        ], [
          {
            url: "/Home/Overview/SwitchControl",
            name: "开关控制",
            img: require('@/assets/img/icon22.png'),
            imgno: require('@/assets/img/icon22-a.png'),
            isclick: false,
          },
          // {
          //     name:"负荷模式",
          //     img:require('@/assets/img/icon20.png'),
          //     imgno:require('@/assets/img/icon20-a.png'),
          //     isclick:false,
          // },
          {
            name: "能耗分析",
            img: require('@/assets/img/icon21.png'),
            imgno: require('@/assets/img/icon21-a.png'),
            url: "/Home/Overview/Comparison",
            isclick: false,
          }
        ], [
          {
            name: "电力拓扑图",
            img: require('@/assets/img/tuopu.png'),
            imgno: require('@/assets/img/tuopu-a.png'),
            url: "/Home/Overview/PowerWiringLine",
            isclick: false,
          }
        ],
        [
          {
            name: "充电桩",
            img: require('@/assets/img/icon24.png'),
            imgno: require('@/assets/img/icon24-a.png'),
            url: "/Home/Overview/Piles",
            isclick: false, 
          }
        ]
      ]
      if (this.projectInfo.menuAuth) {
        let list = ['PowerDistribution', 'Photovoltaic', 'EnergyConsumption', 'PaymentMeter']
        this.projectInfo.menuAuth.split(',').forEach(elm => {
          if (elm == 'PowerDistribution') {
            menu[1][0].isclick = true
            menu[1][1].isclick = true
            menu[1][2].isclick = true
            menu[3][0].isclick = true
            menu[3][2].isclick = true
          }
          if (elm == 'Photovoltaic') {
            menu[0][1].isclick = true
          }
          if (elm == 'EnergyConsumption') {
            menu[5][1].isclick = true

          }
          if (elm == 'PaymentMeter') {
            // menu[3][1].isclick = true
            // menu[7][0].isclick = true
          }
        })
      }

      
      if (this.projectId == 1||this.projectId == 13||this.projectId == 18) {  //开关控制 鳄鱼美 交投  昌华
        menu[5][0].isclick = true
      }
      if (this.projectId == 1) {
        menu[6][0].isclick = true
        menu[3][1].isclick = true
        menu[7][0].isclick = true
        menu[4][0].isclick = true
      }
      if (this.projectId == 13) { //鳄鱼美
        // menu[5][0].isclick = true
        menu[3][1].isclick = true
      }
      if (this.projectId == 17 || this.projectId == 18) { //交投
        // menu[5][0].isclick = true
        menu[5][1].isclick = true
      }
      if (this.projectId == 4) {
        // menu[5][0].isclick = true
        menu[3][1].isclick = true
      }
      // if(this.projectId==1||this.projectId==4||this.projectId==5||this.projectId==16||this.projectId==6){ //电能质量
      //     menu[1][2].isclick = true
      // }
      return menu
    }
  },
  mounted() {
    this.$store.commit('setAreaId', -1)
  },
  methods: {
    tagmenu(item) {
      console.log(item)
      if (!item.isclick) {
        return false
      }
      this.$router.push(item.url)
    }
  }
}
</script>

<style lang="less" scoped>

.icon-left{
  position: absolute;
  left: 0;
  background: #e6e6e6;
  border-radius: 3px;
  height: 60px;
  line-height: 60px;
  text-align: center;
  width: 16px;
  cursor: pointer;
  .el-icon-caret-left{
    color:#777777;
    font-size: 16px;
  }
}

.icon-right{
  position: absolute;
  right: 0;
  background: #e6e6e6;
  border-radius: 3px;
  height: 60px;
  line-height: 60px;
  text-align: center;
  width: 16px;
  cursor: pointer;
  .el-icon-caret-right{
    color:#777777;
    font-size: 16px;
  }
}
.imgshow{
    width: 100%;
    height: 100%;
  img{
    width: 100%;
    height: 100%;
  }
}

#SubstationManagement {
  display: flex;
  flex-wrap: wrap;
  height: 100%;
  justify-content: space-between;
  align-content: space-between;

  .subcontainer-one {
    padding: 1.5vh 1.2vw;
    .h(648);
    .w(1194);
    background: #fff;
    display: flex;
    flex-wrap: wrap;
    align-items: center;
    position: relative;

    .plan {
      display: flex;
      flex-wrap: wrap;
      text-align: center;
      // justify-content: center;
      justify-content: space-around;
      align-items: center;
      // .w(494);
      height: 100%;
      background: rgba(245, 246, 247, 1);
      // background: rgba(13, 148, 255, 0.1);
      border-radius: 16rem;
      color: #cccccc;
      padding: 0 25px 0 25px;

      .name {
        // width: 20%;
        font-size: 30px;
        font-weight: 400;
        width: 15%;
        text-align: left;
        // line-height: 49px;
      }

      // .top{
      //     .h(184)
      // }
      .cont {
        display: flex;
        flex-wrap: wrap;
        text-align: center;

      }

      .item {
        .w(140);
        cursor: pointer;

        img {
          width: 78rem;
          height: 78rem;
        }

        span {
          display: block;
          font-size: 24rem;
        }
      }

      .gray {
        // filter:grayscale(100%);
        color: #cccccc;
        cursor: default;
      }
    }

    .top {
      width: 100%;
      .h(186);
      display: flex;
      flex-wrap: wrap;
      justify-content: space-between;

      .plan {
        .w(570);
      }

      .yuan {
        color: #0D94FF;
        background: rgba(13, 148, 255, 0.1);
      }

      .wang {
        color: #5AD8A6;
        background: rgba(90, 216, 166, 0.1);
      }
    }

    .center {
      width: 100%;
      display: flex;
      flex-wrap: wrap;
      justify-content: space-between;
      // .h(400);
      .left {
        .w(905);
        display: flex;
        flex-direction: column;
        justify-content: space-between;
        align-items: center;
      }

      .right {
        .w(235);
        .h(415);
        display: flex;
        flex-wrap: wrap;

        .plan {
          width: 100%;
          display: flex;
          flex-direction: column;
          justify-content: space-between;
          align-items: center;
        }
      }

      .box {
        .h(193);
        display: flex;
        flex-wrap: wrap;
        justify-content: space-between;
        width: 100%;
      }

      .box1 {
        .h(214);
      }

      .jiesuan {
        .w(231);
        // background: #e5f6ef;
        color: #01AB65
      }

      .dianl {

        .w(666);
        // color: #066FFC;
        // .item  {
        //     width: auto;
        //     img{
        //         width: 279rem;
        //         height: 151rem;
        //     }
        // }

        padding: 0;
        overflow: hidden;
        cursor: url('../../assets/img/move3D.png'), auto;

        & > video {
          width: 100%;
          height: 100%;
          // transform: scaleX(1.085)
        }
      }

      .yunwei {
        .w(570);
        background: rgba(38, 154, 153, 0.1);
        color: #269A99;
      }
      .chong{
        .w(160);
        text-align: center;
        // background: #f2fbf2;
        color: #68D86A;
        .name {
          width: 100%;
          text-align: center;
        }

        .cont {
          // width:50%;
        }
      }
      .chong.gray{
        color: #cccccc;
      }
      
      .chu {
        .w(160);
        text-align: center;
        color: #68D86A;
        // background: #f2fbf2;
        // color: #68D86A;
        .name {
          width: 100%;
          text-align: center;
        }

        .cont {
          // width:50%;
        }
      }
      .chu.gray{
        color: #cccccc;
      }

      .he {
        color: #F9C22B;
        background: rgba(249, 194, 43, 0.1);
        justify-content: space-around !important;
        padding: 20px 0;
      }
    }
  }

  .subcontainer-thr {
    .h(320);
    .w(1194);
    background: #FFFFFF;
  }
}

.animation, .animationSource, .animationNet, .animationEnergy, .animationFill, .animationDouch, .animationNo {
  position: relative;

}

.animation::before, .animationSource::before, .animationNet::before, .animationEnergy::before, .animationFill::before, .animationDouch::before, .animationNo::before {
  content: '';
  width: 65rem;
  height: 65rem;
  border-radius: 50%;
  border: 5rem solid transparent;
  position: absolute;
  top: 32.5%;
  left: 50%;
  transform: translate(-50%, -50%);
}

.animation:hover {
  &::before {
    border: 5rem solid #269A99;
    animation: transform 2.5s infinite;
  }
}

.animationSource:hover {
  &::before {
    border: 5rem solid #0D94FF;
    animation: transform 2.5s infinite;
  }
}

.animationNet:hover {
  &::before {
    border: 5rem solid #5AD8A6;
    animation: transform 2.5s infinite;
  }
}

.animationEnergy:hover {
  &::before {
    border: 5rem solid #cccccc;
    animation: transform 2.5s infinite;
  }
}

.animationFill:hover {
  &::before {
    border: 5rem solid #7bd57d;
    animation: transform 2.5s infinite;
  }
}

.animationDouch:hover {
  &::before {
    border: 5rem solid #F9C22B;
    animation: transform 2.5s infinite;
  }
}

@keyframes transform {
  0% {
    transform: translate(-50%, -50%) scale(1);
    opacity: 1;
  }
  100% {
    transform: translate(-50%, -50%) scale(1.7);
    opacity: 0;
  }
}
</style>